
  export const getHour = (date: string) => date.split("T")[1].split(":")[0];

  export const getMinutes = (date: string) => date.split("T")[1].split(":")[1];

  export const formatAMPM = (date: string) => {
    const hours = getHour(date);
    const minutes = getMinutes(date);
    const ampm = Number(hours) >= 12 ? 'pm' : 'am';
    const newHours = Number(hours) > 12 ? Number(hours) - 12 :  Number(hours);
    return newHours + ':' + minutes + ' ' + ampm;
  }